import Text from './text';

export default {
  defaultProps: {
    size: 'md',
  },
  sizes: Text.sizes,
};
